import Vue from 'vue';
import App from './app.vue';
import router from './router';

// reset css
import "./resources/styles/reset.css";
// fonts
//import "./resources/styles/fonts.scss";

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import { locale } from 'view-design';
import lang from 'view-design/dist/locale/zh-CN';
locale(lang);
Vue.use(ViewUI);

import { api } from "./http-lib/api";
import http from "./http-lib/http-common";
Vue.prototype.http = http;
Vue.prototype.api = api;
Vue.prototype.domain = 'http://127.0.0.1:8000/';

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
